import { Loader2 } from 'lucide-react';
import { createPortal } from 'react-dom';

interface LoadingModalProps {
    isOpen: boolean;
    title: string;
    message?: string;
}

export function LoadingModal({
    isOpen,
    title,
    message
}: LoadingModalProps) {
    if (!isOpen) return null;

    return createPortal(
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            <div
                className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
            />
            <div className="relative bg-white dark:bg-[#00172D] rounded-[2.5rem] shadow-2xl w-[280px] p-8 transform transition-all scale-100 animate-in fade-in zoom-in-95 duration-200 border border-transparent dark:border-white/5 flex flex-col items-center justify-center">
                <Loader2 className="w-12 h-12 text-blue-600 dark:text-blue-400 animate-spin mb-6" />

                <div className="text-center">
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">{title}</h3>
                    {message && (
                        <p className="text-sm text-gray-500 dark:text-gray-400 font-medium leading-relaxed">
                            {message}
                        </p>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
}
